export const MENU_ITEM_PROPERTIES = [
    "name",
    "label",
    "tooltip",
    "icon",
    "showIcon",
    "showAs",
    "entityId",
    "targetPageId",
    "show",
    "recordsToShow"
]

export const RECENT_RECORD_PROPERTIES = [
    "name",
    "label",
    "tooltip",
    "icon",
    "showIcon",
    "showAs",
    "entityId",
    "targetPageId",
    "show",
    "order",
    "recordsToShow",
    "attributes",
]